<template>
  <QRcode
      ref="QRcodeRef"
      v-bind:onError="onError"
      v-bind:onSuccess="onSuccess"
      v-bind:onClose="onClose"
      workerPath="/js/qrWork.js"
      v-bind:config="{tipText:tipText, backButtonText:back}"
  />
</template>

<script>
  import QRcode from "../components/QRcode.vue";
  
  export default {
    name: "scan",
    data() {
      return {
        isB: false,
        text: {},
        tipText:this.$t("message.tipText"),
        back:this.$t("message.Back")
      }
    },
    components: {QRcode},
    methods: {
      onError: function (e) {
        console.log('onError -> onError')
        this.$notify(e.message)
        if (this.isB) {
          this.$router.go(-2)
        } else {
          this.$router.push({name: 'bind-home'})
        }
        // this.getbinfo();
      },
      onSuccess: function (value) {
        console.log('onSuccess -> onSuccess')
        this.$refs.QRcodeRef.close(); //关闭
        if (this.isB) {
          this.getbinfo(value);
        } else {
          let codeStr = value.substring(value.lastIndexOf('/') + 1);
          this.$router.push({name: 'loading', params: {code: codeStr}})
        }
      },
      onClose: function() {
        this.$router.go(-1)
        // if (this.isB) {
        //   this.$router.go(-1)
        // } else {
        //   // this.$router.push({name: 'bind-home'})
        //   this.$router.go(-1)
        // }
      },
      getbinfo(codeBStr) {
        // 判断Code是否符合B码格式
        if(codeBStr.length == 32){
          this.$router.push({name: "B_bind", params: { data: this.text, code: codeBStr }})
        } else {
          this.$notify(this.$t("message.B_fake_scan"))
          this.$router.push({name: 'bind-home'})
        }
      },
    },
    created() {
      this.isB = this.$route.params.data != undefined;
      this.text = this.isB ? this.$route.params.data : {};
    }
  }
</script>

<style scoped>

</style>
